import { ApifirstService } from 'src/app/service/apifirst.service';
import { Inject} from "@angular/core";
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';


@Component({
  selector: 'app-sbdrdsmapping',
  templateUrl: './sbdrdsmapping.component.html',
  styleUrls: ['./sbdrdsmapping.component.scss']
})
export class SbdrdsmappingComponent implements OnInit {
  displayName_1: any = '';
  idsFeedbackName: any = '';
  modelYear: any = '';
  odysseyId: any = '';
  rdsModel: any = '';
  rdsModelYear: any = '';
  vlCode: any = '';
  displayName_1A: any = '';
  idsFeedbackNameA: any = '';
  modelYearA: any = '';
  odysseyIdA: any = '';
  rdsModelA: any = '';
  rdsModelYearA: any = '';
  vlCodeA: any = '';
  sbdRdsList: any = [];
  isBackToTopShowBtn=false;


  constructor(private service: ApifirstService,@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.service.getSbdRds().subscribe((data) => {
      this.sbdRdsList = data
      console.log(this.sbdRdsList.length, "in init")
    })
  }
  addSbdRdsdata() {
     if (this.odysseyId != undefined && this.odysseyId != '' &&
      this.odysseyId != null && this.odysseyId.length !== 0) {
      if (this.displayName_1 == undefined) { this.displayName_1A = '' } else { this.displayName_1A = this.displayName_1 }
      if (this.idsFeedbackName == undefined) { this.idsFeedbackNameA = '' } else { this.idsFeedbackNameA = this.idsFeedbackName }
      if (this.modelYear == undefined) { this.modelYearA = '' } else { this.modelYearA = this.modelYear }
      if (this.rdsModel == undefined) { this.rdsModelA = '' } else { this.rdsModelA = this.rdsModel }
      if (this.rdsModelYear == undefined) { this.rdsModelYearA = '' } else { this.rdsModelYearA = this.rdsModelYear }
      if (this.vlCode == undefined) { this.vlCodeA = '' } else { this.vlCodeA = this.vlCode }
      let req = {
        "displayName_1": this.displayName_1A,
        "idsFeedbackName": this.idsFeedbackNameA,
        "modelYear": this.modelYearA,
        "odysseyId": this.odysseyId,
        "rdsModel": this.rdsModelA,
        "rdsModelYear": this.rdsModelYearA,
        "vlCode": this.vlCodeA
      }
      console.log(req, "add request")
      this.service.addSbdRds(req).subscribe((data) => {
        let res = data;
        console.log(res, "add response")
        this.service.getSbdRds().subscribe((data) => {
          this.sbdRdsList = data
          console.log(this.sbdRdsList, "after adding")
        })
      }, (error) => {
        console.log(error,"error in add")
      });      
      this.clearvariables();
      this.displayName_1 = ''
      this.idsFeedbackName = ''
      this.modelYear = ''
      this.odysseyId = ''
      this.rdsModel = ''
      this.rdsModelYear = ''
      this.vlCode = ''
    }
  }
  clearAllSbdRds() {
    this.displayName_1 = ''
    this.idsFeedbackName = ''
    this.modelYear = ''
    this.odysseyId = ''
    this.rdsModel = ''
    this.rdsModelYear = ''
    this.vlCode = ''
  }
  updateSbdRdsdata(id: any, odysseyId: any, rdsModel: any, rdsModelYear: any, modelYear: any, vlCode: any, displayName_1: any, idsFeedbackName: any) {
    if (odysseyId != undefined && odysseyId != '' && odysseyId != null &&odysseyId.length !== 0) {
      if (displayName_1 == undefined) { this.displayName_1A = '' } else { this.displayName_1A = displayName_1 }
      if (idsFeedbackName == undefined) { this.idsFeedbackNameA = '' } else { this.idsFeedbackNameA = idsFeedbackName }
      if (modelYear == undefined) { this.modelYearA = '' } else { this.modelYearA = modelYear }
      if (rdsModel == undefined) { this.rdsModelA = '' } else { this.rdsModelA = rdsModel }
      if (rdsModelYear == undefined) { this.rdsModelYearA = '' } else { this.rdsModelYearA = rdsModelYear }
      if (vlCode == undefined) { this.vlCodeA = '' } else { this.vlCodeA = vlCode }
      let req = {
        "id": id,
        "displayName_1": this.displayName_1A,
        "idsFeedbackName": this.idsFeedbackNameA,
        "modelYear": this.modelYearA,
        "odysseyId": odysseyId,
        "rdsModel": this.rdsModelA,
        "rdsModelYear": this.rdsModelYearA,
        "vlCode": this.vlCodeA
      }
      console.log(id, req, "update request");
      this.service.updateSbdRds(req).subscribe(
        (data) => {
          console.log(data, "update resposne");
          this.service.getSbdRds().subscribe((data) => {
            this.sbdRdsList = data
            console.log(this.sbdRdsList, "after updating")
          })
        })
      this.clearvariables();
    }
  }
  deleteSbdRdsdata(id: any, odysseyId: any, rdsModel: any, rdsModelYear: any, modelYear: any, vlCode: any, displayName_1: any, idsFeedbackName: any) {
    let req = {
      "displayName_1": displayName_1,
      "id": id,
      "idsFeedbackName": idsFeedbackName,
      "modelYear": modelYear,
      "odysseyId": odysseyId,
      "rdsModel": rdsModel,
      "rdsModelYear": rdsModelYear,
      "vlCode": vlCode
    }
    console.log(req, "delete request");
    this.service.deleteSbdRds(req).subscribe(
      (data) => {
        console.log(data, "delete response");
        this.service.getSbdRds().subscribe((data) => {
          this.sbdRdsList = data
          console.log(this.sbdRdsList, "after deleting")
        })
      }, (error) => {
        console.log(error,"error in delete")
      });
    
  }
  clearvariables() {
    this.displayName_1A = ''
    this.idsFeedbackNameA = ''
    this.modelYearA = ''
    this.odysseyIdA = ''
    this.rdsModelA = ''
    this.rdsModelYearA = ''
    this.vlCodeA = ''
  }
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
       this.isBackToTopShowBtn=true;
    } else {
      this.isBackToTopShowBtn=false;
    }
  }

@HostListener('window:scroll', ['$event']) // for window scroll events
onScroll(event:any) {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    this.isBackToTopShowBtn=true;
 } else {
   this.isBackToTopShowBtn=false;
 }
}
}
